<!--多选 MCQ-->
<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">多选</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
          <b v-if="isCountMust">
            {{ `(必须选${maxCount}项)` }}
          </b>
          <b v-else-if="isCountSwitch">
            {{ `(最多选${maxCount}项，最少${minCount}项)` }}
          </b>
          <b v-else>
            {{ `(最多选${maxCount}项)` }}
          </b>
        </span>
      </p>
    </div>
    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" mode="widthFix" style="width: 100%" />
      </div>
    </div>
    <div v-for="(item, index) in list" :key="index">
      <div
        class="choose-css choose-css-new"
        :class="{ active: item.isChoose }"
        style="
          border: 1px solid rgba(237, 237, 237, 0.5);
          background: rgba(247, 247, 247, 1);
        "
        @click="handleChoose(item, index)"
      >
        <div class="choose-css-text">
          <p
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(43, 47, 54, 1);
            "
          >
            {{ item.text }}
          </p>
          <div v-if="rules.length > 0" style="margin-top: 10px">
            <div
              v-if="rules[index].action === 'jump'"
              style="font-size: 12px; color: #ff9900"
            >
              跳转到({{ rules[index].targets[0] }}、{{
                rules[index].problem
                  ? rules[index].problem.length > 10
                    ? rules[index].problem.slice(0, 10) + "..."
                    : rules[index].problem
                  : ""
              }})
            </div>
            <div
              v-else-if="this.rules[index].action === 'end'"
              style="font-size: 12px; color: #ff9900"
            >
              {{ "问卷结尾，结束答题" }}
            </div>
            <div v-else style="font-size: 9px; color: #ff9900"></div>
          </div>
          <div
            class="select-icon"
            style="
              border: 1px solid rgba(237, 237, 237, 1);
              background: #ffffff;
            "
          ></div>
        </div>

        <div class="question-images">
          <div
            class="question-images-box"
            @click.stop="showBigImage(imgItem, item)"
            v-for="(imgItem, imgIndex) in item.img_path"
            :key="imgIndex"
            style="margin-top: 10px; position: relative"
          >
            <img :src="imgItem" mode="aspectFill" class="thumbnail-image" />
            <div class="fangda-box">查看图片</div>
          </div>
        </div>
      </div>
      <div v-if="item.is_fill && item.isChoose" class="option-item-bottom">
        <div class="option-item-bottom-input">
          <input
            placeholder-class="input-placeholder"
            type="text"
            placeholder="编辑提示词"
            v-model="item.fill_prompt"
            @blur="handleBlur(item, index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObj: {},
      answerObj: {},
      index: 0,
      list: [],
      count: 3,
      isMultiple: true,

      images: [],
      rules: [],
      isCountMust: null,
      maxCount: null,
      minCount: null,
      isCountSwitch: null,
    };
  },
  methods: {},
  watch: {
    params: {
      handler(newVal) {
        this.dataObj = newVal.data;
        this.index = newVal.index;
        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");

        const chooseList = JSON.parse(newVal.data.chooseList);
        this.list = chooseList.list || [];
        this.isCountMust = chooseList.isCountMust;
        this.maxCount = chooseList.maxCount;
        this.minCount = chooseList.minCount;
        this.isCountSwitch = chooseList.isCountSwitch;

        if (newVal.answer && Array.isArray(newVal.answer.answer)) {
          const answerIds = newVal.answer.answer.map((a) => parseInt(a.id));
          this.list.forEach((item) => {
            item.isChoose = answerIds.includes(parseInt(item.id));
          });
        } else {
          this.list.forEach((item) => (item.isChoose = false));
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.question-logic {
  position: absolute;
  right: 13px;
  top: 28px;
  width: 13px;
  height: 12px;
}

.choose-css-new.active .select-icon {
  background: rgba(58, 96, 255, 1) !important;
  position: relative;
}

.choose-css-new.active .select-icon::after {
  display: block;
  content: "";
  width: 6px;
  height: 10px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  margin-top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewMCQ.vue